var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new_vip"},[_c('div',{staticClass:"content"},[_c('shop-order')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }